import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const ToggleButton = styled(motion.button)`
  background-color: ${props => props.$isDark ? '#333' : '#fff'};
  color: ${props => props.$isDark ? '#fff' : '#333'};
  border: 1px solid ${props => props.$isDark ? '#444' : '#ddd'};
  border-radius: 30px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  outline: none;
  
  &:hover {
    background-color: ${props => props.$isDark ? '#444' : '#f0f0f0'};
    color: ${props => props.$isDark ? '#fff' : '#333'};
    border-color: ${props => props.$isDark ? '#666' : '#ccc'};
  }
`;

const IconWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Sun icon for light mode
const SunIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" />
    <path d="M12 2V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 12L2 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M22 12L20 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M19.7782 4.22183L17.5564 6.44365" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M6.44365 17.5564L4.22183 19.7782" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M19.7782 19.7782L17.5564 17.5564" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M6.44365 6.44365L4.22183 4.22183" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Moon icon for dark mode
const MoonIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDarkMode = theme.mode === 'dark';

  return (
    <ToggleButton
      onClick={toggleTheme}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      $isDark={isDarkMode}
    >
      <IconWrapper
        initial={{ rotate: 0 }}
        animate={{ rotate: isDarkMode ? 360 : 0 }}
        transition={{ duration: 0.5 }}
      >
        {isDarkMode ? <MoonIcon /> : <SunIcon />}
      </IconWrapper>
      {isDarkMode ? 'Dark' : 'Light'}
    </ToggleButton>
  );
};

export default ThemeToggle;
